import { ModuleTextColumnsFragment } from '@/graphql';
import { FC } from 'react';
import TextColumns from '@/components/_organisms/TextColumns';
import { parseHtml } from '@/lib/parse-html';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';
import useBreakpoint from '@/lib/hooks/useBreakpoint';
import TextColumnWithImage from '@/components/_atoms/text-columns/TextColumnWithImage';
import Heading from '@/components/_atoms/Heading';
import styled from 'styled-components';

interface TextColumnsModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleTextColumnsFragment>;
}

const TextColumnsModule: FC<TextColumnsModuleProps> = ({ props, className }) => {
  const [currentBreakpoint] = useBreakpoint();

  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props || !props.columns) return null;

  return (
    <>
      {props.heading && <StyledHeading level={2}>{props.heading}</StyledHeading>}

      <TextColumns className={className} imageSize={(props.imageSize as 'small' | 'large' | null) ?? undefined}>
        {props.columns.filter(notEmpty).map((column) => {
          switch (column.__typename) {
            case 'textColumns_Columns_iconColumn_BlockType':
              const icon = getSingle(column.icon);
              const mobileIcon = getSingle(column.mobileIcon);

              if (!icon || !icon.url || !column.title) return null;

              let iconSrc = icon.url;

              if (currentBreakpoint === 'mobile' && mobileIcon?.url) {
                iconSrc = mobileIcon.url;
              }

              return (
                <TextColumnWithImage imageSrc={iconSrc} title={column.title}>
                  {parseHtml(column.description)}
                </TextColumnWithImage>
              );
            case 'textColumns_Columns_imageColumn_BlockType':
              const image = getSingle(column.image);

              if (!image || !image.url || !column.title) return null;

              return (
                <TextColumnWithImage imageSrc={image.url} title={column.title}>
                  {parseHtml(column.description)}
                </TextColumnWithImage>
              );
          }
        })}
      </TextColumns>
    </>
  );
};

export default TextColumnsModule;

const StyledHeading = styled(Heading)`
  text-align: center;
`;
